import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  checkPositionNameRoutine,
  mergePositionsRoutine
} from './routines';
import { checkPositionName, mergePositions } from '../../services/positionService';
import { successToast, errorToast } from '../../common/helpers/toastrHelper';

function* checkPositionNameReq({ payload }: Routine<any>) {
  try {
    const { isNameTaken } = yield call(checkPositionName, payload);
    yield put(checkPositionNameRoutine.success(isNameTaken));
  } catch (error) {
    yield put(checkPositionNameRoutine.failure(error.message));
  }
}

function* watchCheckPositionNameReq() {
  yield takeEvery(checkPositionNameRoutine.TRIGGER, checkPositionNameReq);
}

function* mergePositionsReq({ payload }: Routine<any>) {
  try {
    yield call(mergePositions, payload);
    yield put(mergePositionsRoutine.success());
    yield call(successToast, 'Merge successful', 'toast.mergeSuccess');
  } catch (error) {
    yield put(mergePositionsRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchMergePositionsReq() {
  yield takeEvery(mergePositionsRoutine.TRIGGER, mergePositionsReq);
}

export default function* mergePositionsSaga() {
  yield all([
    watchCheckPositionNameReq(),
    watchMergePositionsReq()
  ]);
}
